module.exports = "/_next/static/files/121b12dd4a34277f8e9b9f0300f241c9.png";